import classes from "./CharacterInfo.module.css";
import { Button, Heading, Text } from "components/common";

import { useAppContext } from "ContextProvider/ContextProvider";

import { ProIcon } from "images";
const CharacterInfo = ({ logo, icon, name, info, requires_pro }) => {
  const { myTheme } = useAppContext();
  return (
    <div className={classes.wrapper}>
      <div className={classes.imgTitleAndInfo}>
        {icon && <img src={icon} alt="#" className={classes.img} />}
        {logo && <span className={classes.logo}>{logo}</span>}
        <div className={classes.infoContainer}>
          <Heading primitive50 lg medium textCenter className={classes.heading}>
            {name}
            {!requires_pro && (
              <span className={classes.icon}>
                <ProIcon color={myTheme.color} />
              </span>
            )}
          </Heading>
          <Text sm primitive300 textCenter className={classes.info}>
            {info}
          </Text>
        </div>
      </div>
      {requires_pro && (
        <Button
          onClick={() => {}}
          primitiveTransparent8
          className={classes.button}
        >
          Upgrade to Pro
        </Button>
      )}
    </div>
  );
};
export default CharacterInfo;
